// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__13QgU","range":"MonthRangeSwitch_range__ECZd3","disabled":"MonthRangeSwitch_disabled__22fUn"};